// extracted by css-extract-rspack-plugin
module.exports =  {"fix-email":"FixEmail-BNc5__fix-email"};